import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare var flash: any;

const CUSTOM_ERROR: any = {
  UnacceptableAmount: 'High Slippage',
  InsufficientEquity: 'Insufficient equity',
  WithdrawTooMuch: 'Warning, withdrawal balance unavailable, please reduce the amount and try again',
  PoolUnavailable: 'Insufficient liquidity, please try again',
  // PoolUnavailable: 'Pool fully Utlilized, try a differnet amount',
  Unavailable: 'Insufficient Balance',
  TradeDisabled: 'Trade halted',
  ZeroPrice: 'Trade value must be >0',
  UnacceptablePrice: 'High Slippage',
  NotOwner: 'Not Owner',
  InvalidSize: 'Trade value must be >0'
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  constructor(
    protected translateService: TranslateService
  ) {
  }

  success(key: string | string[], interpolateParams?: Object | undefined, options?: any) {
    flash.success(this.translateService.instant(key, interpolateParams), options);
  }

  info(key: string | string[], interpolateParams?: Object | undefined, options?: any) {
    flash.info(this.translateService.instant(key, interpolateParams), options);
  }

  warning(key: string | string[], interpolateParams?: Object | undefined, options?: any) {
    flash.warning(this.translateService.instant(key, interpolateParams), options);
  }

  error(key: string | string[], interpolateParams?: Object | undefined, options?: any) {
    flash.error(this.translateService.instant(key, interpolateParams), options);
  }

  handleError(error: any) {
    console.dir(error)
    if (this.isCancel(error)) {
      return;
    }
    this.parseErrors(error).forEach((e) => this.error(e));
  }

  isCancel(error: any) {
    return error && error.code === 4001 || error?.message?.includes('denied');
  }

  parseWeb3Error(e: any, defaultMessage: string) {
    console.log(e);
    let errorMessage = '';
    if (e.customError) {
      errorMessage = this.parseCustomError(e.customError);
    } else {
      const message = e.innerError?.message || e.data?.message || e.message;
      let result = message.match(/execution reverted: (.*?)$/);
      if (!result) {
        result = message.match(/transaction: revert (.*?)$/);
      }
      errorMessage = result && result[1] || message;
    }
    return errorMessage || defaultMessage;
  }

  parseErrors(error: any, defaultMessage = 'Unknown error'): string[] {
    if (error.error) {
      if (error.error.custom_error) {
        const customError = this.parseCustomError(error.error.custom_error);
        if (customError) {
          return [customError];
        }
      }
      return error.error.errors || [defaultMessage];
    } else if (typeof error === 'string') {
      return [error];
    } else {
      return [this.parseWeb3Error(error, error.message || defaultMessage)];
    }
  }

  private parseCustomError(customError: any) {
    console.log(customError);
    let error = CUSTOM_ERROR[customError.name];
    if (typeof error === 'object') {
      error = error[customError.dataArray[0]]
    }
    return error;
  }
}
